import React from "react";
import {
  Box,
  Text,
  Heading,
  Image,

  Container,
} from "@chakra-ui/react";
import bgimg from '../../assets/about/aboutbg.png'
import Success from "../home/component/Success";
import Footer from "../header/Footer";
import OtherNews from "../contactUs/OtherNews";
import useScrollAnimation from "component/useScrollAnimation";

const Blogs = () => {
  useScrollAnimation();
  return (
    <>
    
    <Box position="relative" zIndex={0} overflow="visible">
    <Box bg="white" pt="80px">
      {/* Top Section */}
      <Container maxW="container.xl" textAlign="center" py={10}>
        <Heading size="lg" color="#005770" className="fade-in-up">
          What is the branding, and why we need it?
        </Heading>
        <Text mt={2} color="#5D5F64" className="fade-in-up">
          Let's transform your ideas into roaring success. As a trusted digital
          marketing company in Jaipur and one of the best SEO companies in
          India, we’re here to help. Reach out to us and experience the magic of
          Marwadi-style innovation!
        </Text>
      </Container>

      {/* Image Section */}
      <Box maxW="5xl" mx="auto">
        <Image
          src={bgimg}
          alt="Cafe Image"
          borderRadius="md"
          objectFit="cover"
          w="100%"
          className="fade-in-up"
        />
      </Box>

      {/* Description Section */}
      <Container maxW="5xl" py={8}>
        <Text color="gray.700" lineHeight="1.8" className="fade-in-up">
          We are a small cafe, with a big dream of becoming a global cafe. We
          started our operations in Singapore, and we are now expanding to
          Beijing and other countries. Realizing the Mission of Global
          Expansion, Open its First Cafe in Singapore.
        </Text>

        <Text mt={4} color="gray.700" lineHeight="1.8" className="fade-in-up">
          The cafe is located at Dempsey Hill, a family-friendly neighborhood
          with a wide range of restaurants and cafes. Global Expansion Cafe aims
          to introduce new tastes and flavors to Singaporeans and tourists from
          different cultures.
        </Text>

        <Text mt={4} color="gray.700" lineHeight="1.8" className="fade-in-up">
          We are currently running our pop-up shop in Singapore and hope to
          launch our main cafe soon. We believe in love and happiness and want
          to provide financial services globally.
        </Text>

        <Text mt={4} color="gray.700" lineHeight="1.8" className="fade-in-up">
          We partner with companies who LOVE the world. The cafe is a place
          where people can enjoy coffee and food, while also learning about
          finance and the digital world.
        </Text>

        <Text mt={4} color="gray.700" lineHeight="1.8" className="fade-in-up">
          The cafe offers a wide range of drinks including specialty coffees,
          teas, smoothies, milkshakes, and frozen yogurts.
        </Text>
      </Container>
    
    </Box>
    <OtherNews/>
    <Success/>
    </Box>
    <Footer/>
    </>
  );
};

export default Blogs;
